import styles from "./programData.module.scss";
import { LevelComponent } from "../LevelComponent/levelComponent";
import { CourseCardComponent } from "../CourseCardComponent/courseCardComponent";
import ButtonComponent from "../ButtonComponent/buttonComponent";
import { CallUsAt } from "../CallUsAtComponent/callUsAt";
import { connect } from "react-redux";
import { promReduxConnect } from "../../util/utils";
import { PureComponent } from "react";

const ListComponent = (props) => {
    const { title, points = [] } = props;

    return (
        <div className={styles.detailsContainer}>
            {title ? <div className={styles.title}>{title}</div> : null}

            {points?.length > 0 ? (
                <div className={styles.listContainer}>
                    <ul className={styles.list}>
                        {points?.map((point) => (
                            <li className={styles.listItem} key={point}>
                                {point}
                            </li>
                        ))}
                    </ul>
                </div>
            ) : null}
        </div>
    );
};

const requirements = {
    title: "Requirements",
    points: [
        "No programming experience needed - we'll teach you everything you need to know",
        "We will provide you a computer for the duration of the program in our office.",
        "No paid software required. We have our own learning platform where you wil spend all of your time."
    ],
};

const RegisterBatchComponent = (props) => {
    const { item = {}, showImage = true, programBatch } = props;

    if (!programBatch?.batchStartDate) {
        return
    }

    return (
        <div className={styles.registerComponent}>
            <div className={styles.badge}>New Batch Starts on {
            new Date(programBatch?.batchStartDate).toDateString()}</div>
            <div className={styles.title}>Join This Batch</div>
            {/* <FormComponent /> */}
            <div className={styles.buttonContainer}>
                <div className={styles.limitedNotes}>Limited Seats available</div>

                <ButtonComponent className={styles.registerButton} type="dark" onClick={() => {
                    props.navigate(`/app/register?batchId=${programBatch?.batchId}`);
                }}>
                    Register
                </ButtonComponent>
            </div>
        </div>
    );
};

class PythonDeveloperProgramComponentInternal extends PureComponent {
    render = () => {
        const { navigate, allBatches } = this.props;
        const details = {};
        const { allCourses = {} } = this.props;
        const programId = "pydev"

        const onHandleRedirection = (id) => {
            const url = `/app/courses?courseId=${id}`;
            navigate(url);
        };

        const faqs = [
            {
                questionHtml: "Should I come to office every day?",
                answerHtml: `This is an offline internship.
            You must make arrangements to come to spend at least 8 hours everyday
            in the office in Gachibowli`,
            },
            {
                questionHtml: "Will I get a computer in the office?",
                answerHtml: `Yes, you will get a computer in the office. You may need to 
            arrange your own laptop if you want to work on the tasks from home.
            `,
            },
            {
                questionHtml: "Will there be a learning platform?",
                answerHtml: `Yes, you will get access to Plovi AI designed custom-built learning
            platform featuring lessons, practical exercises, real-world projects and exams.
            `,
            },
            {
                questionHtml: "How long will have access to online learning material?",
                answerHtml: `12 months from the start of the internship. 
            You will have access to all online material for 12 months 
            from the start of the internship. You can retain lifetime access by paying a fees
            after 12 months.
            `,
            },
            {
                questionHtml: "Will I get a certificate?",
                answerHtml: `You will get Python Developer Internship certificate from Plovi AI upon finishing
            the internship
            `,
            },
            {
                questionHtml:
                    "Can I share my certificate of completion with employers while applying for jobs?",
                answerHtml: `Yes. You will also get an online link with verified certificate 
            that you can share with employers while applying for jobs.
            `,
            },
            // {
            //     questionHtml: `I already paid for some of the individual courses in the program, 
            // will I get a discount?`,
            //     answerHtml: `Yes. The amount already paid for the courses will be refunded from the program fees.
            //     Please contact support for refund.
            // `,
            // },
            // {
            //     questionHtml: `I want to try the three courses online before joining the program.`,
            //     answerHtml: `Yes. the three courses part of the program are available on our learning platform.
            // You can register for each of the course on a trial basis without any payment and
            // do some initial modules. You can also pay for them and get access to full course,
            // any amount paid for the course will be deducted from program fees payment when you join.
            // Please note that first course(PY101) is a prerequisite for the other two courses,
            // you should only try the other two after finishing the first course.
            // `,
            // },
            {
                questionHtml: `Does this internship guarantee job after doing it?`,
                answerHtml: `No. We do not guarantee placements. We will provide basic resume preparation and
            interview training. Our internship is rigorous, you will be able to write code in interviews after 
            finishing our internship. As we grow bigger, we will try to contact the employers
            to market our trainees to them, but there is no guarantee we will be able to 
            get you a job at this point. Please do not fall for any other coaching institutes,
            online training websites claiming to provide placement guarantee.  
            `,
            },
            // {
            //     questionHtml: `What if I do not finish the internship within 3 months?`,
            //     answerHtml: `The program is designed to be finished in 3 months by an average learner
            // new to coding. If you do not finish all the mandatory exercises/exams
            // or if there are some optional exercises still left, you will have access to course
            // material for 12 months, you can finish them from home after 3 months.
            // `,
            // },
            // {
            //     questionHtml: `What if I do not clear the final exam?`,
            //     answerHtml: `You will not get a certificate if you do not clear the final offline coding exam.
            // However, you can take the final offline more than once,
            // any number of times by paying a small fees
            // for upto 12 months, to get the certificate.
            // `,
            // },
            // {
            //     questionHtml: `Do I have to pay one month salary if I get a job?`,
            //     answerHtml: `Yes. If you do not already have a tech/coding job you will have to sign
            // and an agreement to pay one month salary (
            //     1/12th of yearly CTC) to Plovi AI if you get a 
            // coding/tech job after attending this program within 12 months.
            // If you already have a coding/tech job or if you do not want to
            // enter into this agreement for any other reason, you can choose to pay Rs. 15000 extra
            // as program fees over the regular program fees and not have this agreement.
            // `,
            // },
            {
                questionHtml: `Who are the mentors?`,
                answerHtml: `Anil Muthineni and his team will teach and mentor on a daily basis.
            Anil is a top-notch software engineer/computer scientist with >12 years experience
            and has worked for Microsoft,
            Google USA in
            the past. He is currently
            the cofounder of his own AI startup. He graduated from IIT Kanpur in
            Computer Science.
            `,
            },
            {
                questionHtml: `Who can get the best out of this internship?`,
                answerHtml: `This internship is designed for beginners without any prior coding experience.
            However, the exercises slowly increase in complexity. So, it will also be helpful for 
            people already familiar with coding to sharpen their coding skills. 
            Below are some of the candidates for whom this may be a good fit.
            <ul>
            <li>Recent graduates or final year students looking to  apply for tech jobs
            </li>
            <li>Candidates looking to shift jobs and want to sharpen coding skills for Interviews.
            </li>
            <li>Candidates looking to move to USA or other countries for masters 
            and want to sharpen coding skills before departure.
            </li>
            <li>People from non-tech jobs, looking to enter into tech/coding jobs.
            </li>
            </ul>
            `,
            },
            {
                questionHtml: `Whom should I contact if I have more questions about the internship?`,
                answerHtml: `Please contact our support center at support@plovi.ai and +919515656894 to know more. 
            `,
            },
            {
                questionHtml: `How should I pay registration fees and reserve the seat?`,
                answerHtml: `Please use the "Register" button 
            above to register for the internship.
            After registration, our support team will contact you for payment of registration fees
            to reserve your seat. Your registration will get cancelled automatically if you do not pay
            registration fees within 3 days.  
            `,
            },
            // {
            //     questionHtml: `Are there limited seats?`,
            //     answerHtml: `This is an offline internship. We need to provide you a dedicated
            // office desk with computer for the full duration of the internship. 
            // We have limited office space in Gachibowli, please reserve your seat as soon as possible 
            // if you are interested.  
            // `,
            // },
            {
                questionHtml: `What is the refund policy?`,
                answerHtml: `You will get full no-questions asked refund if you decide to 
            join the internship on first day and leave the internship within five days of the start of the internship.
            Your registration fees will not be refunded if you do not join the internship.
            `,
            },
        ];

        if (!allBatches) {
            return null
        }

        const currentTimestampMillis = Date.now()
        const programBatches = Object.values(allBatches).filter(batch => {
            const batchStartDateMillis = +new Date(batch?.batchStartDate || '2024-01-01')
            return batch?.programId === 'pydev' && batchStartDateMillis >= currentTimestampMillis
        })

        const programCourseIds = ['py101', 'mysql101', 'django101']

        return (
            <div className={styles.container}>
                <div className={styles.topHeaderContainer}>
                    <div className={styles.leftSideContainer}>
                        <div className={styles.headerTitle}>Python Developer Internship</div>
                        <div className={styles.subText}>{details?.subText}</div>
                        <div className={styles.subInfo}>
                            <LevelComponent level={"Beginner"} />
                            <div className={styles.timePeriod}>
                                <svg
                                    width="16"
                                    height="18"
                                    viewBox="0 0 16 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M2.16667 17.3332C1.70833 17.3332 1.31597 17.17 0.989583 16.8436C0.663194 16.5172 0.5 16.1248 0.5 15.6665V3.99984C0.5 3.5415 0.663194 3.14914 0.989583 2.82275C1.31597 2.49637 1.70833 2.33317 2.16667 2.33317H3V0.666504H4.66667V2.33317H11.3333V0.666504H13V2.33317H13.8333C14.2917 2.33317 14.684 2.49637 15.0104 2.82275C15.3368 3.14914 15.5 3.5415 15.5 3.99984V15.6665C15.5 16.1248 15.3368 16.5172 15.0104 16.8436C14.684 17.17 14.2917 17.3332 13.8333 17.3332H2.16667ZM2.16667 15.6665H13.8333V7.33317H2.16667V15.6665ZM2.16667 5.6665H13.8333V3.99984H2.16667V5.6665ZM8 10.6665C7.76389 10.6665 7.56597 10.5866 7.40625 10.4269C7.24653 10.2672 7.16667 10.0693 7.16667 9.83317C7.16667 9.59706 7.24653 9.39914 7.40625 9.23942C7.56597 9.0797 7.76389 8.99984 8 8.99984C8.23611 8.99984 8.43403 9.0797 8.59375 9.23942C8.75347 9.39914 8.83333 9.59706 8.83333 9.83317C8.83333 10.0693 8.75347 10.2672 8.59375 10.4269C8.43403 10.5866 8.23611 10.6665 8 10.6665ZM4.66667 10.6665C4.43056 10.6665 4.23264 10.5866 4.07292 10.4269C3.91319 10.2672 3.83333 10.0693 3.83333 9.83317C3.83333 9.59706 3.91319 9.39914 4.07292 9.23942C4.23264 9.0797 4.43056 8.99984 4.66667 8.99984C4.90278 8.99984 5.10069 9.0797 5.26042 9.23942C5.42014 9.39914 5.5 9.59706 5.5 9.83317C5.5 10.0693 5.42014 10.2672 5.26042 10.4269C5.10069 10.5866 4.90278 10.6665 4.66667 10.6665ZM11.3333 10.6665C11.0972 10.6665 10.8993 10.5866 10.7396 10.4269C10.5799 10.2672 10.5 10.0693 10.5 9.83317C10.5 9.59706 10.5799 9.39914 10.7396 9.23942C10.8993 9.0797 11.0972 8.99984 11.3333 8.99984C11.5694 8.99984 11.7674 9.0797 11.9271 9.23942C12.0868 9.39914 12.1667 9.59706 12.1667 9.83317C12.1667 10.0693 12.0868 10.2672 11.9271 10.4269C11.7674 10.5866 11.5694 10.6665 11.3333 10.6665ZM8 13.9998C7.76389 13.9998 7.56597 13.92 7.40625 13.7603C7.24653 13.6005 7.16667 13.4026 7.16667 13.1665C7.16667 12.9304 7.24653 12.7325 7.40625 12.5728C7.56597 12.413 7.76389 12.3332 8 12.3332C8.23611 12.3332 8.43403 12.413 8.59375 12.5728C8.75347 12.7325 8.83333 12.9304 8.83333 13.1665C8.83333 13.4026 8.75347 13.6005 8.59375 13.7603C8.43403 13.92 8.23611 13.9998 8 13.9998ZM4.66667 13.9998C4.43056 13.9998 4.23264 13.92 4.07292 13.7603C3.91319 13.6005 3.83333 13.4026 3.83333 13.1665C3.83333 12.9304 3.91319 12.7325 4.07292 12.5728C4.23264 12.413 4.43056 12.3332 4.66667 12.3332C4.90278 12.3332 5.10069 12.413 5.26042 12.5728C5.42014 12.7325 5.5 12.9304 5.5 13.1665C5.5 13.4026 5.42014 13.6005 5.26042 13.7603C5.10069 13.92 4.90278 13.9998 4.66667 13.9998ZM11.3333 13.9998C11.0972 13.9998 10.8993 13.92 10.7396 13.7603C10.5799 13.6005 10.5 13.4026 10.5 13.1665C10.5 12.9304 10.5799 12.7325 10.7396 12.5728C10.8993 12.413 11.0972 12.3332 11.3333 12.3332C11.5694 12.3332 11.7674 12.413 11.9271 12.5728C12.0868 12.7325 12.1667 12.9304 12.1667 13.1665C12.1667 13.4026 12.0868 13.6005 11.9271 13.7603C11.7674 13.92 11.5694 13.9998 11.3333 13.9998Z"
                                        fill="white"
                                    />
                                </svg>
                                3 months
                            </div>
                        </div>
                    </div>
                    <div className={styles.rightSideContainer}>
                        <RegisterBatchComponent programBatch={programBatches?.[0]} navigate={navigate} />
                    </div>
                </div>
                <div className={styles.details}>
                    <div className={styles.innerDetails}>
                        <ListComponent
                            title={`Introduction`}
                            points={[
                                `This internship introduces you to coding starting with Hello world program in Python.`,
                                `Prior experience with coding is not necessary. People with experience in coding can also do the internship, 
                                it will start with the basics and takes you upto medium level complex logic.`,
                                `This internship takes you through three courses listed below. First course covers basics of coding, and is equivalent to 
                                most universities' undergraduate first year coding course. Second course introduces you to databases using MySQL, 
                                you should be able to write most commonly used sql queries after taking this course. 
                                Third course introduces you to writing backend code using Python Django framework.`,
                                `You can try some of the modules in all three courses for free on our website`,
                                `This internship is meant to give hands on experience writing code, you will spend almost 
                                all of your time writing code.`,
                                `This is a 3 months offline internship. You are expected to attend our office in Gachibowli, Hyderabad
                                for full day on all working days`,
                                `This is a hands on program. You will have a mentor team assisting you all the time.
                                Anil Muthineni and team will guide/teach or clear doubts every day or as and when needed.`,
                                `Limited seats available. Please reserve your seat by paying registration fees or full fees.`,
                                `No paid software required. We have our own learning platform where you wil spend all of your time. 
                                We will provide you a computer for the duration of the internship in our office.`
                                
                                // `You should also agree to pay Plovi AI one month salary/CTC if you get a
                                // coding/tech job within one year of starting the program.
                                // Please see FAQs for more details.`
                            ]}
                        />
                        <ListComponent
                            title={details?.whatYouWillLearn?.title}
                            points={details?.whatYouWillLearn?.points}
                        />
                        {/* <ListComponent
                            title={requirements?.title}
                            points={requirements?.points}
                        /> */}
                        <div className={styles.detailsContainer}>
                            <div className={styles.title}>Batches</div>
                            <div className={styles.listContainer}>
                                <ul className={styles.list}>
                                    {programBatches?.map((programBatch) => (
                                        <li className={styles.listItem} key={programBatch.batchId}>
                                            Start date: {new Date(programBatch?.batchStartDate).toDateString()} <br/>
                                            Fees:  
                                                <span style={{textDecoration: "line-through"}}>
                                                    {programBatch?.priceBeforeDiscount?.quantity ? `Rs. ${
                                                    programBatch?.priceBeforeDiscount?.quantity / 100}`: ""}
                                                </span>
                                                    Rs. {programBatch?.price?.quantity / 100}
                                                {programBatch?.priceBeforeDiscount?.quantity ?
                                                ` (Introductory price for first few seats)`: ""}
                                                 <br/>
                                            Registration Fees: Rs. {programBatch?.registrationFee?.quantity / 100}<br/>
                                            <ButtonComponent size="small" type="primary" onClick={() => {
                                                navigate(`/app/register?batchId=${programBatch?.batchId}`);
                                            }}>Register</ButtonComponent>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <ListComponent
                            title={`Location`}
                            points={[`Gachibowli, Hyderabad. Please see our office address for exact location`]}
                        />
                        <ListComponent
                            title={`Registration/Refund policy`}
                            points={[
                                `You can reserve your seat for any of the batches listed above by paying either the registration fees
                                or full fees.`,
                                `You have to pay the full fees latest by the second day of the internship. 
                                Our team will contact you for more information once you register.`,
                                `Full refund without any questions, including registration fees, if you join and decide to
                                 leave within first 5 days of the internship. No refund of registration fees if you do not showup
                                 on the first day of the internship.`
                            ]}
                        />

                        {programCourseIds?.length > 0 ? (
                            <div className={styles.programPlans}>
                                <div className={styles.cardsTitle}>{"Program Plan"}</div>
                                <div className={styles.cardsSubTitle}>
                                    {`${programCourseIds?.length} Course${programCourseIds?.length > 1 ? `s` : ``
                                        }`}
                                </div>

                                <div className={styles.cardsList}>
                                    {programCourseIds?.length > 0 &&
                                        programCourseIds?.map((info) => {
                                            if (allCourses[info]?.courseName !== "Intermediate Python") {
                                                return (
                                                    <CourseCardComponent
                                                        key={allCourses[info]?.courseId}
                                                        title={allCourses[info]?.courseName}
                                                        timePeriod={allCourses[info]?.courseDuration}
                                                        subText={allCourses?.[info]?.courseDescriptionHtml}
                                                        primaryButtonText={"Explore Course"}
                                                        primaryButtonType="dark"
                                                        onPrimaryClick={() =>
                                                            onHandleRedirection(allCourses[info]?.courseId)
                                                        }
                                                        doNotShowCourseLength={true}
                                                    />
                                                );
                                            }
                                        })}
                                </div>
                            </div>
                        ) : null}
                        <div className={styles.detailsContainer}>
                            <div className={styles.title}>Mentors</div>

                            <div className={styles.instructorDetails}>
                                <div className={styles.instructorInfo}>
                                    <span className={styles.intructorName}>
                                        <a href="https://www.linkedin.com/in/anil-muthineni-32b61518"
                                        target="_blank"
                                    >Anil Muthineni</a></span> and the team
                                </div>
                                <div className={styles.instructorExperience}>
                                    
                                {`Anil Muthineni is a top-notch software engineer/computer scientist with >12 years experience and 
                                    has worked for Microsoft and Google in USA in the past. He is currently the cofounder of his own AI startup.
                                    He graduated from IIT Kanpur in Computer Science.`}
                                </div>
                            </div>
                            <div className={styles.detailsContainer}> FAQs
                                {faqs && faqs.map((faq) => {
                                    return <div className={styles.instructorDetails}>
                                        <div className={styles.instructorName}>{faq?.questionHtml}</div>
                                        <div className={styles.instructorExperience}  dangerouslySetInnerHTML={{ __html: faq?.answerHtml || "" }}>
                                            
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={styles.registerTabMobContainer}>
                        <RegisterBatchComponent programBatch={programBatches?.[0]} programId={programId} />
                    </div>
                </div>

                <CallUsAt />
            </div>
        );
    }
};

export const PythonDeveloperProgramComponent = promReduxConnect(
    PythonDeveloperProgramComponentInternal, (state, ownProps) => {
        return {
            allBatches: state.common.allBatches,
            allCourses: state.common.allCourses,
        };
    }
)
